import styled from "@emotion/styled"
import Drawer from "@material-ui/core/Drawer"
import List from "@material-ui/core/List"
import DocketIcon from "components/Icons/Docket.icon"
import QuestionmarkIcon from "components/Icons/Questionmark.icon"

export const StyledDrawer = styled(Drawer)`
  width: 9rem;
` as typeof Drawer

export const StyledList = styled(List)`
  padding-top: 5.5rem;
  flex-grow: 1;
` as typeof List

export const IconWrap = styled.div`
  display: flex;
  justify-content: center;
  height: 7rem;
  align-items: center;
`

export const StyledDocketIcon = styled(DocketIcon)`
  font-size: 5.5rem;
  color: ${({ theme }) => theme.palette.common.white};
`

export const StyledQuestionMarkIcon = styled(QuestionmarkIcon)`
  font-size: 3.6rem;
`
